import { createModel } from '@rematch/core';
import type { RootModel } from '@/models';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { ContasPagarState } from './types';
import { effects } from './effects';

const initialState: ContasPagarState = {
    deleteAnexo: initReduxFn,
    estornar: initReduxFn,
    estornarLancamento: initReduxFn,
    get: initReduxFn,
    getOne: initReduxFn,
    getTotais: initReduxFn,
    pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: false,
        showTotal: () => '',
        total: 22,
    },
    post: initReduxFn,
    postAnexo: initReduxFn,
    postLancamento: initReduxFn,
    put: initReduxFn,
    selectAll: false,
    selectedRowKeys: [],
    selectedRows: [],
    showCompartilhar: false,
    showDrawerCompartilhar: false,
    showModal: false,
    showPagar: false,
    showPixCobranca: false,
    showSelectAll: false,
    sortParams: {
        fieldName: '',
        orderDirection: 'asc',
        shouldSort: false,
    },
    tableHistorico: [],
};

export const ContasPagarModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<ContasPagarState>(),
    state: initialState,
});
